import { GlobalStore } from "@roc/feature-app-core";
import { capitalize, flatten, isNil, LoanProcess } from "@roc/feature-utils";
import { action, flow, makeObservable, observable } from "mobx";
import { ReplyInTaskService } from "../services/replyInTaskService";
import { Message } from "@twilio/conversations";
import { MessageAttribute } from "../types/communicationTypes";
import { LoanCommunicationStore } from "./loanCommunicationStore";

type LoanTaskSelectOption = {
  value: number;
  label: string;
}

export class ReplyInTaskStore {
  private replyInTaskService: ReplyInTaskService;
  globalStore: GlobalStore;
  loanCommunicationStore: LoanCommunicationStore;
  isModalOpen: boolean;
  loanId: number;
  taskId: number;
  loanTaskOptions: LoanTaskSelectOption[];
  selectedTask: LoanTaskSelectOption;
  selectedMessage: Message;
  readOnly: boolean;

  constructor(globalStore, userStore, communicationService) {
    this.globalStore = globalStore;
    this.replyInTaskService = new ReplyInTaskService();
    this.loanCommunicationStore = new LoanCommunicationStore(globalStore, userStore, communicationService);

    this.setDefaults();
    makeObservable(this, {
      isModalOpen: observable,
      loanId: observable,
      setModalOpen: action,
      setLoanId: action,
      taskId: observable,
      setTaskId: action,
      fetchLoanTaskOptions: flow,
      setSelectedTask: action,
      loanTaskOptions: observable,
      sendReplyingToMessage: flow,
      selectedMessage: observable,
      setSelectedMessage: action,
      readOnly: observable,
      setReadOnly: action,
    });
  }

  reset() {
    this.setDefaults();
    this.loanCommunicationStore.reset();
  }

  setDefaults() {
    this.isModalOpen = false;
    this.loanId = null;
    this.taskId = null;
    this.loanTaskOptions = [];
    this.selectedTask = null;
    this.selectedMessage = null;
    this.readOnly = false;
  }

  setModalOpen(modalOpenValue: boolean) {
    this.isModalOpen = modalOpenValue;
  }

  setLoanId(loanIdValue: number) {
    this.loanId = loanIdValue;
  }

  setTaskId(taskIdValue: number) {
    this.taskId = taskIdValue;
  }

  setReadOnly(readOnly: boolean) {
    this.readOnly = readOnly;
  }

  *fetchLoanTaskOptions() {
    try {
      const response = yield this.replyInTaskService.getLoanTaskOptions(
        this.loanId,
        capitalize(LoanProcess.UNDERWRITING),
        null,
        true,
        null,
      );
      const data = JSON.parse(response.data.data);
      const documents = flatten(Object.values(data));
      const options = documents.map(doc => {
        const option = {
          label: doc.sectionName + ' - ' + doc.taskName,
          value: doc.taskId
        } as LoanTaskSelectOption
        if (!isNil(this.taskId) && this.taskId == doc.taskId) {
          this.setSelectedTask(option);
        }
        return option;
      });

      this.loanTaskOptions = options;
    } catch (e) {
      console.log('error', e);
    }
  }

  setSelectedTask(task) {
    this.selectedTask = task;
  }

  *sendReplyingToMessage() {
    try {
      const attributes = this.selectedMessage.attributes as MessageAttribute;
      const body = {
        id: this.taskId,
        message: this.selectedMessage.body,
        author: attributes.authorName,
      };

      const response = yield this.replyInTaskService.sendReplyInTaskMessage(body);

    } catch (e) {
      console.log('error on sendReplyingToMessage', e);
    }
  }

  setSelectedMessage(message: Message) {
    this.selectedMessage = message;
  }

}